<template>
  <div>
    <el-dialog
        title="加油站信息展示"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="close"
        :close-on-click-modal="false">
      <div>
        <el-table :data="tableData" :max-height="500" stripe>
          <el-table-column fixed type="index" width="50" align="center" label="序号"></el-table-column>
          <el-table-column prop="stationName" label="油站名称" align="center"></el-table-column>
          <el-table-column prop="brand" label="品牌" align="center"></el-table-column>
          <el-table-column prop="address" label="地址" align="center"></el-table-column>
          <el-table-column prop="provname" label="省份" align="center"></el-table-column>
          <el-table-column prop="cityname" label="城市" align="center"></el-table-column>
          <el-table-column prop="countyname" label="区县" align="center"></el-table-column>
          <el-table-column prop="stopCount" label="月停靠次数" align="center"></el-table-column>
        </el-table>
<!--        <div class="block">-->
<!--          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"-->
<!--                         layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>-->
<!--        </div>-->
      </div>
    </el-dialog>

  </div>
</template>
<script>
import http from "api/freight";
import Util from "utils/util";

export default {
  props: {
    currRow: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      dialogVisible: true,
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 20,
    }
  },
  mounted() {
    this.initDate()
  },
  methods: {
    initDate() {
      const params = {
        companyId: this.currRow.companyId,
        year:this.currRow.year,
        month:this.currRow.month
      }
      http
          .gasStationInfo(params)
          .then((e) => {
            if (e.code == 200 && e.data && e.data) {
              this.tableData = e.data
            } else {
              this.tableData = []
            }
          })
    },
    handleCurrentChange(index) {
      this.currentPage = index
      this.initDate()
    },
    close() {
      this.$emit('closeTask', 'seeTopFiveIs')
    },
  }
}
</script>
<style lang="stylus" scoped>
.block {
  display: flex;
  padding: 5px 0;

  .center {
    margin: 10px auto;
  }
}

/deep/ .el-dialog__body {
  padding: 0 !important;
//border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}
</style>
